import { Route } from 'vue-router/types/router';
import { Next } from '@/types';
import router, { loadLang } from '@/config/router/router';
import { axios } from '@/config/plugins/axios';
import ErrorHandler from '@/services/errorHandler/ErrorHandler';
import jwtTokenManager from '@/services/Security/jwtTokenManager';
import userInfoService from '@/services/Security/UserInfo/userInfoService';
import { i18n } from '@/i18n';
import notificationManager from '@/services/Notification/NotificationManager';

const loginCookieName = 'patientExperienceLoginCookie';

const UnauthorizedHttpException = 'Symfony\\Component\\HttpKernel\\Exception\\UnauthorizedHttpException';

const patientExperienceLoginService = {
	checkAuthentication(to: Route, from: Route, next: Next) {
		// If the user isn't logged and don't have a token
		if (!this.isLogged(to)) {
			router.push({ name: 'unauthorized' });
		} else {
			const token = to.query.token as string;
			if (!jwtTokenManager.getToken(loginCookieName) || (token !== jwtTokenManager.getToken(loginCookieName))) {
				jwtTokenManager.saveToken(token, loginCookieName);
			}

			this.decorateAxiosInstance(jwtTokenManager.getToken(loginCookieName));
			userInfoService.updateAppState(null, true, false);

			loadLang().then(() => next());
		}
	},

	isLogged(to: Route): boolean {
		return Boolean(to.query.token);
	},

	decorateAxiosInstance(token: string | null): void {
		const authorization = 'Authorization';

		// We add the authentication token to every header of every request
		if (token) {
			axios.defaults.headers.common[authorization] = token;
		}

		const unauthorizedCallback = () => {
			notificationManager.displayMessage('error', i18n.t('views.patientExperienceSurvey.expiredLink'));
		};
		ErrorHandler.addGlobalHandlingTypeException(UnauthorizedHttpException, 401, unauthorizedCallback);
	}
};

export default patientExperienceLoginService;
